import React from 'react';
import { TextField, InputAdornment, Box, IconButton } from '@mui/material';
import { Controller } from 'react-hook-form';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';

const CustomLogSignInput = ({
    control,
    name,
    placeholder,
    icon: Icon,
    rules = {},
    defaultValue = '',
    helperText = '',
    type = 'text',
    fontSize = '0.8rem',
    iconSize = 16,
    height = 34,
    setValue,
}) => {
    const [passShow, setPassShow] = React.useState();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
            render={({ field, fieldState }) => (
                <Box component={'div'}
                    sx={{
                        position: 'relative',
                    }}>
                    <TextField
                        {...field}
                        type={type === 'password' ? (passShow ? 'text' : 'password') : type}
                        variant="outlined"
                        size="small"
                        fullWidth
                        placeholder={placeholder}
                        error={!!fieldState?.error}
                        helperText={fieldState?.error?.message ?? helperText}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                fontSize: fontSize,
                                height: height,
                                // backgroundColor: 'var(--bgWhitePrimary)',
                                backgroundColor: 'transparent',

                                '&:hover fieldset': {
                                    borderColor: 'lightgray',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'var(--bgGreenPrimary)',
                                },
                            },
                        }}
                        InputProps={{
                            startAdornment: Icon ? (
                                <InputAdornment position="start">
                                    <Icon color="#B6BBC4" size={iconSize} />
                                </InputAdornment>
                            ) : null,
                        }}

                        onChange={(e) => {
                            const rawValue = e.target.value;
                            const value = type === 'tel' ? rawValue.replace(/[^0-9]/g, '') : rawValue;
                            field.onChange(value);
                            if (setValue) setValue(value);
                        }}
                    />
                    {type === 'password' && <IconButton
                        onClick={() => setPassShow(!passShow)}
                        aria-label="eye"
                        size="small"
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}>
                        {passShow ? <HiOutlineEye fontSize="inherit" /> : <HiOutlineEyeOff fontSize="inherit" />}
                    </IconButton>}
                </Box>
            )}
        />
    );
};

export default CustomLogSignInput;
